module.exports = __webpack_public_path__ + "img/ok-grey-ico.5805eba6.svg";